export default __webpack_public_path__ + "static/media/finance_report-ioc.ff93fff3.png";